import { Fragment } from 'react';

import { Button } from '@playbooks/ui/components/button';
import { FarIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

const AccountSwitchFragment = ({ session, workspace, onSelect, onCreate = undefined, className = '' }) => {
	const workspaces = session.user?.workspaces || [];

	// Methods
	const isActive = (type, candidate) => workspace.type === type && workspace.workspace.id === candidate.id;
	const thumbnail = model => (typeof model?.thumbnail === 'object' ? model.thumbnail?.src : model?.thumbnail);
	const preview = model => {
		const src = thumbnail(model);
		return src ? { src, className: 'size-9 rounded-panel' } : null;
	};
	const planName = model => {
		const name = model?.subscription?.name || (model?.subscription?.isPro ? 'Pro' : 'Free');
		return /plan$/i.test(name) ? name : `${name} plan`;
	};
	const WorkspaceStatus = ({ type, model }) =>
		isActive(type, model) ? <FarIcon icon='check' className='size-3 text-foreground' /> : null;

	// Theme
	const rootClassName = cn('flex-column! min-h-0 gap-1 p-2', className);

	// Render
	return (
		<Fragment>
			<ul data-slot='account-switch-list' className={rootClassName}>
				{workspaces.map(candidate => (
					<li key={candidate.id}>
						<Button
							data-menu-contained
							type='button'
							variant='ghost'
							prevImg={preview(candidate)}
							data-active={isActive(candidate.type, candidate)}
							aria-current={isActive(candidate.type, candidate) ? 'true' : undefined}
							onClick={() => onSelect(candidate.type, candidate)}
							className='min-h-14 w-full justify-start gap-3 p-2'>
							<span className='flex-column min-w-0 grow items-start gap-0.5 text-left'>
								<span className='w-full truncate text-base leading-none'>{candidate.name}</span>
								<span className='text-xs font-normal text-foreground-body'>{planName(candidate)}</span>
							</span>
							<WorkspaceStatus type={candidate.type} model={candidate} />
						</Button>
					</li>
				))}
				{onCreate ? (
					<li className='-mx-2 mt-auto border-t border-border px-2 pt-1'>
						<Button type='button' variant='ghost' prevIcon='plus' onClick={onCreate} className='w-full justify-start'>
							<span className='min-w-0 grow text-left'>New workspace</span>
						</Button>
					</li>
				) : null}
			</ul>
		</Fragment>
	);
};
export { AccountSwitchFragment };
